import { createDynamicPopup } from './popup';

declare const jQuery: JQueryStatic;
const $ = jQuery;

export function initVideoSliders(): void {
    $('.video-slider').each(function () {
        const $wrap = $(this);
        const $slider = $wrap.find('.finite-slider');
        const $sliderItems = $slider.find('.slider-item');
        const $prev = $wrap.find('.chevron-prev');
        const $next = $wrap.find('.chevron-next');
        $slider.on('slide', (event, data) => {
            data.prevAllowed ? $prev.addClass('show') : $prev.removeClass('show');
            data.nextAllowed ? $next.addClass('show') : $next.removeClass('show');
        });
        $prev.on('click', () => {
            $slider.trigger('slide-to-prev-group');
        });
        $next.on('click', () => {
            $slider.trigger('slide-to-next-group');
        });
        $next.addClass('show');
        $sliderItems.each(function () {
            const $sliderItem = $(this);
            const videoHtml = $sliderItem.attr('data-slider-item-video');
            if (!videoHtml) return;
            $sliderItem.find('.video-slider-button').on('click', function () {
                createDynamicPopup({
                    content: videoHtml,
                    className: 'video-embed-popup',
                    closeOthersOnOpen: true,
                    openImmediately: true,
                    putCloseBtn: true,
                    removeOnClose: true,
                });
            });
        });
    });
}
